import { Stack } from 'expo-router'
import { stableStackOptions } from '../../../lib/navigation/stable-stack-options'

export default function HostingLayout() {
  return (
    <Stack screenOptions={{ headerShown: false, ...stableStackOptions }}>
      <Stack.Screen name="index" />
      <Stack.Screen name="listings" />
      <Stack.Screen name="earnings" />
      <Stack.Screen name="payouts/index" />
      <Stack.Screen name="payouts/onboarding" />
      <Stack.Screen name="calendar/[vehicleId]" />
      <Stack.Screen name="new-listing" />
      <Stack.Screen name="organization" />
    </Stack>
  )
}
